module.exports = __webpack_public_path__ + "img/DROP-6-820x1024.0a6a4014.png";